/* eslint react/prefer-stateless-function: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  Container,
  Grid,
  Header,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import NavBar from '../../components/NavBar';
import BookDashIcons from '../../components/Svgs/BookDash';
import { namespaces } from '../../constants/translation';

class Dash extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isDeveloper: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    t: PropTypes.func,
  }
  static defaultProps = {
    auth: {
      isAdminBasic: false,
    },
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  modules = [
    {
      name: 'Logos',
      description: 'Logo for projects',
      type: 'pictures',
      route: '/media/logos/',
      icon: 'logo',
      enabled: true,
      isBranchLeader: false,
      isDeveloper: false,
      isSiteplan: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Pictures',
      description: 'Gallery for Site plan, Unit layout & Map',
      type: 'pictures',
      route: '/media/pictures/',
      icon: 'picture',
      enabled: true,
      isBranchLeader: false,
      isDeveloper: false,
      isSiteplan: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Documents',
      description: 'Brochures & Forms',
      type: 'documents',
      route: '/media/documents/',
      icon: 'folder open',
      enabled: true,
      isBranchLeader: false,
      isDeveloper: false,
      isSiteplan: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
    {
      name: 'Videos',
      description: 'Videos from external websites',
      type: 'documents',
      route: '/media/videos/',
      icon: 'folder open',
      enabled: true,
      isBranchLeader: false,
      isDeveloper: false,
      isSiteplan: false,
      isHeadquarters: true,
      isSuperAdmin: true,
    },
  ];
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Media', { ns: 'screens' })}
        />
        <Grid doubling columns={4} className="dash_grid">
          {
            this.modules
            .filter((module) => {
              if (this.props.auth.isSuperAdmin) {
                return module.isSuperAdmin;
              }
              if (this.props.auth.isHeadquarters) {
                return module.isHeadquarters;
              }
              if (this.props.auth.isDeveloper) {
                return module.isDeveloper;
              }
              return true;
            })
            .map((module, idx) => {
              if (module.type) {
                return (
                  <Grid.Column key={idx}>
                    <Link to={module.route}>
                      <Header textAlign="center" as="h3">
                        <p>
                          <BookDashIcons
                            type={module.type}
                            width="6em"
                            height="6em"
                            backfill="#F8F8F8"
                            iconfill="#00233B"
                          />
                        </p>
                        {t(module.name).toUpperCase()}
                        <Header.Subheader>
                          {t(module.description)}
                        </Header.Subheader>
                      </Header>
                    </Link>
                  </Grid.Column>
                );
              }
              return null;
            })
          }
        </Grid>
      </Container>
    );
  }
 }

Dash.contextTypes = {
  store: PropTypes.object,
};

export default withTranslation(namespaces)(connect(Dash.mapStateToProps)(Dash));



// WEBPACK FOOTER //
// ./src/containers/Media/Dash.jsx